import { VehicleSection } from '@/components/VehicleSection/VehicleSection';
import { HowItWorksCTA } from '@/reports/shared/ReportSection/components';
import { AutomobileExports } from '@/reports/types/vehicles';
import { Table, Text, useTheme, useMediaQuery } from '@/theme/index';

export interface VehicleExportsProps {
  /** A list of all export data (open/closed/null) */
  vehicleExportList: AutomobileExports;
}

function HowItWorksCTAContent() {
  return (
    <Text
      variant="body2"
      fontSize="0.9rem"
      color={(theme) => theme.palette.grey[800]}
    >
      This section contains all US used vehicles being exported to countries
      outside the US. Mexico and Canada are considered cross-border and not
      exports. This data does not contain Imports into the US. Exports also may
      include vehicles that have been presented for exportation but haven’t left
      the US.
    </Text>
  );
}

/** This component renders a table view of the export data */
export const VehicleExports: React.FC<VehicleExportsProps> = ({
  vehicleExportList,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const header = ['Export Date', 'State', 'Status'].map((cell) => {
    return (
      <Text variant="h5" sx={{ p: 1, m: 0 }}>
        {cell}
      </Text>
    );
  });

  const modifiedExportList = vehicleExportList.map((vehicleExport) => {
    const date = vehicleExport?.date?.full || '-';
    const state = vehicleExport?.state || '-';
    const status = vehicleExport?.status || '-';
    return [date, state, status].map((cell) => {
      return (
        <Text variant="body2" sx={{ p: theme.spacing(1) }}>
          {cell}
        </Text>
      );
    });
  });

  const modifiedMobileExportList = vehicleExportList?.map((vehicleExport) => {
    const date = vehicleExport?.date?.full || '-';
    const state = vehicleExport?.state || '-';
    const status = vehicleExport?.status || '-';

    return (
      <Table
        className="striped styleless-header mobile"
        headers={[
          <Text
            variant="h5"
            sx={{
              p: 0,
              m: 0,
            }}
          >
            {date}
          </Text>,
        ]}
        rows={[
          ['State', state],
          ['Status', status],
        ]}
      />
    );
  });

  return (
    <VehicleSection
      headers={header}
      tableData={modifiedExportList}
      mobileTableData={modifiedMobileExportList}
      reportSectionTitle="Export records"
      emptySectionTitle="export"
      sectionId="vehicle-exports"
      howItWorks={<HowItWorksCTA content={HowItWorksCTAContent()} />}
    >
      <Text
        variant="body2"
        sx={{
          color: theme.palette.secondary.contrastText,
          mt: isMobile ? theme.spacing(0) : theme.spacing(2),
        }}
      >
        Exports include used vehicles being exported to countries outside the
        U.S. , Mexico and Canada are considered cross-border and not exports.
      </Text>
    </VehicleSection>
  );
};
